module.exports = __webpack_public_path__ + "static/media/emptyStateImg.ad45dc96.svg";